import BaseRepository from '@/api/repositories/BaseRepository';

export default class HelpContactRepository extends BaseRepository {
	sendMessage(message, videoCallPreferred) {
		return this.post('help-contact', {}, { message: message, videoCallPreferred: videoCallPreferred });
	}
}
